import { render, staticRenderFns } from "./PostedBillDetails.vue?vue&type=template&id=6ede518f&"
import script from "./PostedBillDetails.vue?vue&type=script&lang=js&"
export * from "./PostedBillDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports